import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M4.5 7.999C6.43 7.999 8 6.43 8 4.5S6.43 1 4.5 1 1 2.57 1 4.5s1.57 3.499 3.5 3.499zM4.5 3C5.327 3 6 3.673 6 4.5c0 .826-.673 1.499-1.5 1.499S3 5.326 3 4.5C3 3.673 3.673 3 4.5 3zm9 7.001c-1.93 0-3.5 1.569-3.5 3.499s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.499-3.5-3.499zm0 4.999c-.827 0-1.5-.673-1.5-1.5 0-.826.673-1.499 1.5-1.499s1.5.673 1.5 1.499c0 .827-.673 1.5-1.5 1.5zm1.793-13.706l-14 13.998 1.414 1.414 14-13.998-1.414-1.414z" />
  </svg>
);

export default SvgComponent;
